import React from 'react';
import BandMembers from './BandMembers/BandMembers';
import { BandMembersEpoch } from '../Band.interface';
import { environments } from 'environments/environments';
import { byIdDescending } from 'libs/functions/order';

export default class BandMembersList extends React.Component {
  state = {
    bandMembersEpochs: [] as BandMembersEpoch[]
  }

  componentDidMount() {
    this.getEpochList();
  }

  getEpochList() {
    fetch(environments.server + '/data/band_members_epochs.json', { cache: 'no-cache' })
      .then(async response => {
        const data: BandMembersEpoch[] = await response.json();
        const bandMembersEpochs = data.sort(byIdDescending);
        const thisYear = new Date().getFullYear();
        if (+bandMembersEpochs[0].from !== +thisYear) {
          bandMembersEpochs[0].to = thisYear;
        }
        this.setState({ bandMembersEpochs });
      })
      // TODO: Display error message to user when data not loaded
      .catch(e => console.error('Seznam členů kapely nebyl úspěšně načten.\n', e));
  }

  render() {
    const renderEpochs = this.state.bandMembersEpochs.map(epoch => <BandMembers bandMembers={epoch} listed={true} key={epoch.id} />)
    return (
      <div>
        {renderEpochs}
      </div>
    );
  }
}